import { PopoverButton } from '@headlessui/react';
import type { ComponentType, SVGProps } from 'react';

import { umamiTrack } from '../../../../utils/umami';
import { usePresentationContext } from '../context/presentation';

interface DesktopQuickTourProps {
  icon?: ComponentType<SVGProps<SVGSVGElement>>;
  name: string;
}

export function DesktopQuickTour(props: DesktopQuickTourProps) {
  const { name, icon: Icon } = props;
  const { setShowPresentation } = usePresentationContext();

  return (
    <PopoverButton
      className="w-full cursor-pointer group relative flex gap-x-6 rounded-lg p-3 text-sm/6 hover:bg-neutral-50"
      onClick={() => {
        setShowPresentation(true);
        umamiTrack('quickTour');
      }}
    >
      {Icon && (
        <div className="mt-1 flex size-11 flex-none items-center justify-center rounded-lg bg-neutral-50 group-hover:bg-white">
          <Icon className="size-6 text-neutral-600 group-hover:text-primary-600" />
        </div>
      )}
      <div className="flex items-center font-semibold text-neutral-900">
        {name}
      </div>
    </PopoverButton>
  );
}
